export const JOURNEY_ID_PARAM = 'journeyId';
